<ul class="wrap-breadcrumb">
  <li *ngFor="let item of breadcrumb">
    <a [routerLink]="item.link" class="item">{{ item.text }}</a>
  </li>
</ul>
